
import { mapActions, mapState } from "vuex";
import NestedMenu from "@/components/Menu/NestedMenu";
import NestedNavMenu from "@/components/bars/NestedNavMenu";

export default {
  name: "MainNavbar",
  components: { NestedNavMenu, NestedMenu },
  props: {
    isTop: Boolean,
    isAuth: Boolean,
    navMenu: { type: Array, default: () => [] },
  },
  data() {
    return {
      fullMenu: false,
    };
  },
  mounted() {
    console.log(this.navMenu)
  },
  computed: {
    ...mapState("user", ["isLoading"]),
    ...mapState("user", ["currentUser"]),
    ...mapState("notification", ["totalNotification"]),
  },
  async fetch() {
    this.getNotificationCount();
  },
  methods: {
    ...mapActions("notification", ["getNotificationCount"]),

    toggleDrawer() {
      this.$emit("toggle-drawer");
    },
    login() {
      this.$emit("open-login");
    },
    openSearch() {
      this.$emit("open-search");
    },
  },
  watch: {
    $route: {
      handler(value) {
        if (this.currentUser) {
          if (!!this.searchTimer) {
            clearTimeout(this.searchTimer);
            this.searchTimer = null;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
